import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { isAdmin, loginAdmin } from "../utils/auth"; // make sure these are named exports

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // Redirect if already logged in
  useEffect(() => {
    if (isAdmin()) navigate("/", { replace: true });
  }, [navigate]);

  // Submit login
  const submit = async (e) => {
  e.preventDefault();
  setError("");
  setLoading(true);

  const result = await loginAdmin(username, password);

  if (result.success) {
    const dest = location.state?.from || "/";
    navigate(dest, { replace: true });
  } else {
    setError(result.message); // show backend message
  }

  setLoading(false);
};

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "70vh",
        background: "#f5f5f5",
        padding: 20,
      }}
    >
      <form
        onSubmit={submit}
        style={{
          width: 340,
          background: "#fff",
          padding: 24,
          border: "1px solid #eee",
          borderRadius: 12,
          boxShadow: "0 8px 24px rgba(0,0,0,.08)",
        }}
      >
        <h2 style={{ marginBottom: 16, textAlign: "center" }}>Admin Login</h2>
        {error && (
          <div
            style={{
              color: "#a8071a",
              marginBottom: 12,
              fontWeight: 700,
              textAlign: "center",
            }}
          >
            {error}
          </div>
        )}
        <div style={{ display: "grid", gap: 12 }}>
          <input
            className="top-search"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
          <input
            className="top-search"
            placeholder="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button
            type="submit"
            className="logout-btn"
            disabled={loading}
            style={{ padding: "10px", cursor: loading ? "not-allowed" : "pointer" }}
          >
            {loading ? "Connexion..." : "Login"}
          </button>
        </div>
      </form>
    </div>
  );
}